export const PARTICLE_ASSETS = {
    CIRCLE_GLOW: 'https://specterr.b-cdn.net/particle.png',
    CIRCLE_BASIC: 'https://specterr.b-cdn.net/basic-particle.png',
    HEART_GLOW: 'https://specterr.b-cdn.net/heart-particle.png',
    HEART_BASIC: 'https://specterr.b-cdn.net/heart-basic-particle.png',
    STAR_GLOW: 'https://specterr.b-cdn.net/star-particle.png',
    STAR_BASIC: 'https://specterr.b-cdn.net/star-basic-particle.png',
    NOTE_GLOW: 'https://specterr.b-cdn.net/note-particle.png',
    NOTE_BASIC: 'https://specterr.b-cdn.net/note-basic-particle.png',
};